import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';

export interface LanguageOption {
    value: string;
    label: string;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {
    private LANGUAGE_OPTIONS: LanguageOption[] = [
        { value: 'EN', label: 'English' },
        { value: 'JP', label: '日本語' },
    ];

    private templateCache: any = {};

    valueLookup: { [languageValue: string]: LanguageOption } = {};
    private currentLanguage = this.LANGUAGE_OPTIONS[0];
    private onLanguageChanged$: Subject<LanguageOption> = new Subject();

    constructor(private translateService: TranslateService) {
        for (let i = 0; i < this.LANGUAGE_OPTIONS.length; i++) {
            this.valueLookup[this.LANGUAGE_OPTIONS[i].value] = this.LANGUAGE_OPTIONS[i];
        }
    }

    onLanguageChanged(): Observable<LanguageOption> {
        return this.onLanguageChanged$;
    }

    getCurrentLanguage(): LanguageOption {
        return this.currentLanguage;
    }

    setCurrentLanguage(languageValue: string): void {
        const nextLang = this.getByValue(languageValue);

        if (!nextLang) {
            throw new Error(`Language not found: ${languageValue}`);
        }

        this.translateService.use(languageValue.toLowerCase());
        this.currentLanguage = nextLang;

        this.onLanguageChanged$.next(this.currentLanguage);
    }

    public getLanguages(): LanguageOption[] {
        return this.LANGUAGE_OPTIONS;
    }

    public getByValue(languageValue: string): LanguageOption {
        return this.valueLookup[languageValue];
    }
}
